import { useState, useCallback, useRef } from 'react'
import { DatePickerProps } from './types'
import { useOutsideClick } from 'ui/hooks/useOutsideClick'
import { Input } from 'ui/atoms/Input'
import { format, parseISO } from 'date-fns'
import { DateDropdown } from './components/DateDropdown'
import { DATEPICKER_DEFAULT_FORMAT } from 'constants/date'
import styles from './styles.module.scss'

export const DatePicker = ({
  size = 'large',
  selectedDay,
  handleDayChange,
  label,
  placeholder,
  tooltip,
  error,
  isRequired,
  disabled,
  dateFormat = DATEPICKER_DEFAULT_FORMAT,
  defaultMonth,
  fromDate,
  toDate,
}: DatePickerProps) => {
  const fromInputRef = useRef(null)
  const [showDatePicker, setShowDatePicker] = useState(false)
  const closeDatePicker = useCallback(() => {
    setShowDatePicker(false)
  }, [])

  const onIconClick = () => setShowDatePicker(!showDatePicker)

  useOutsideClick(fromInputRef.current, closeDatePicker, {
    enabled: true,
    additionalElements: [],
  })

  const handleOpen = () => {
    setShowDatePicker(true)
  }

  const parsedDate =
    typeof selectedDay === 'string' ? parseISO(selectedDay) : selectedDay

  return (
    <div
      className={styles['date-picker']}
      ref={fromInputRef}
      data-testid="date-picker"
    >
      <Input
        readonly
        value={selectedDay ? format(parsedDate, dateFormat) : ''}
        iconRight="CalendarIcon"
        iconSize="medium"
        placeholder={placeholder}
        iconSpace="small"
        iconColor={disabled ? 'grey200' : 'blue700'}
        size={size}
        label={label}
        disabled={disabled}
        tooltip={tooltip}
        error={error}
        iconOnClickRight={onIconClick}
        onClick={handleOpen}
        typographyName="body2WMedium"
        isRequired={isRequired}
        dataTestId="date-input"
      />
      {showDatePicker && !disabled && (
        <DateDropdown
          selectedDay={selectedDay ? parsedDate : undefined}
          changeValue={handleDayChange}
          handleClose={closeDatePicker}
          defaultMonth={defaultMonth}
          fromDate={fromDate}
          toDate={toDate}
        />
      )}
    </div>
  )
}
